export const WAREHOUSE_FETCHING = 'WAREHOUSE_FETCHING';
export const WAREHOUSE_RECEIVED = 'WAREHOUSE_RECEIVED';
export const WAREHOUSE_ERROR = 'WAREHOUSE_ERROR';
export const WAREHOUSE_SELECTED = 'WAREHOUSE_SELECTED';

export const PRODUCT_SEARCH = 'PRODUCT_SEARCH';
